
export default function Enrollment() {
  return (
    <section className="py-16 bg-gradient-to-r from-red-500 to-red-600 text-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-2">
              MATRÍCULAS ABERTAS!
            </h2>
            <p className="text-xl md:text-2xl">
              Venha fazer parte do time The Joy School Paulínia
            </p>
          </div>
          <a 
            href="https://wa.me/5519989250972?text=Olá,%20vi%20o%20site%20e%20gostaria%20de%20mais%20informações%20sobre%20matrículas%20na%20The%20Joy%20School%20Paulínia."
            className="bg-white text-red-600 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
          >
            Fale com a The Joy
          </a>
        </div>
      </div>
    </section>
  );
}
